import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { MarkAsReadFn } from "@tKgpco/Services/ReadAllMsgService";

import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type Parameters = {
    msgIds: string[];
} & HasOnSuccess &
    HasOnError;
type HandlerType = ApiHandler<Parameters>;

export const PopulateApiParameter: HandlerType = props => {
    const { msgIds } = props.parameter;
    props.apiParameter = {
        msgIds,
    };
};

export const updateDashboardMsgStatus: HandlerType = async props => {
    try {
        const apiResult = await MarkAsReadFn(props.apiParameter.msgIds);
        if (apiResult) {
            props.parameter.onSuccess?.(apiResult);
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);

            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    if (props.parameter?.onSuccess) {
        props.parameter.onSuccess();
    }
};

export const chain = [PopulateApiParameter, updateDashboardMsgStatus, ExecuteOnSuccess];

const markAllAsRead = createHandlerChainRunner(chain, "markAllAsRead");
export default markAllAsRead;
